var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-inner"},[_c('h3',{staticClass:"font-weight-bold"},[_vm._v("Galeria")]),_vm._v(" "),_c('viewer',{staticClass:"images clearfix",attrs:{"images":_vm.images}},_vm._l((_vm.images),function(src){return _c('img',{key:src,staticClass:"image",attrs:{"src":src.data,"alt":src.title}})}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb70fe12","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/partial/validations/ValidationImages.vue
// module id = null
// module chunks = 